import { TKey } from "@/app/translations/TKey";
import { CallPeriod } from "@/app/types/call/CallPeriod";

export const CALL_PERIOD_KEYS: Record<CallPeriod, TKey> = {
  [CallPeriod.ALL]: TKey.CALL_ANALYSIS_PERIOD_ALL,
  [CallPeriod.LAST_7_DAYS]: TKey.CALL_ANALYSIS_PERIOD_7_DAYS,
  [CallPeriod.LAST_30_DAYS]: TKey.CALL_ANALYSIS_PERIOD_30_DAYS,
  [CallPeriod.LAST_90_DAYS]: TKey.CALL_ANALYSIS_PERIOD_90_DAYS,
  [CallPeriod.LAST_12_MONTHS]: TKey.CALL_ANALYSIS_PERIOD_12_MONTHS,
  [CallPeriod.THIS_YEAR]: TKey.CALL_ANALYSIS_PERIOD_THIS_YEAR,
  [CallPeriod.CUSTOM]: TKey.CALL_ANALYSIS_PERIOD_CUSTOM,
};

export const CALL_PERIOD_ORDER: CallPeriod[] = [
  CallPeriod.ALL,
  CallPeriod.LAST_7_DAYS,
  CallPeriod.LAST_30_DAYS,
  CallPeriod.LAST_90_DAYS,
  CallPeriod.LAST_12_MONTHS,
  CallPeriod.THIS_YEAR,
  CallPeriod.CUSTOM,
];
